<p-confirmDialog></p-confirmDialog>
<p-confirmDialog key="confirm"></p-confirmDialog>
<app-feedback-host #feedbackHost></app-feedback-host>
<app-ai-assistant-host #assistantHost></app-ai-assistant-host>
<app-assistance-launcher [assistant]="assistantHost" [feedback]="feedbackHost"></app-assistance-launcher>
<router-outlet></router-outlet>
<p-toast key="globalToast"></p-toast>

<!-- ngx-ui-loader component for displaying the spinner -->
<ngx-ui-loader></ngx-ui-loader>
